export const META = {
  fr: {
    locale: "fr_FR",
    imageAlt:
      "Aperçu de la page d'accueil de HorsIndex, projet de présentation et de ressources consacré à l'exposition numérique.",
    routes: {
      "/": {
        title: "HorsIndex | Réduire la surface publique d'exposition",
        description:
          "HorsIndex est un projet consacré à la maîtrise de l'exposition numérique des personnes et des organisations. Son ouverture commerciale est différée.",
      },
      "/audit-initial": {
        title: "Audit initial d'une exposition numérique | HorsIndex",
        description:
          "Première étape d'examen d'une situation d'exposition numérique : sources visibles, cartographie initiale et premières recommandations documentées.",
      },
      "/simon-marie": {
        title: "Simon Marie - Boulogne-sur-Mer | HorsIndex",
        description:
          "Simon Marie, à Boulogne-sur-Mer, développe HorsIndex autour de la protection des données personnelles, de la conformité et de la réduction de l'exposition numérique.",
      },
      "/contact": {
        title: "Contact | HorsIndex",
        description:
          "Pour contacter Simon Marie au sujet de HorsIndex, de ses contenus ou pour toute autre demande, utilisez le formulaire de contact.",
      },
      "/desindexation": {
        title: "Déréférencement Google : retirer un résultat associé à votre nom | HorsIndex",
        description:
          "Un résultat indésirable apparaît lorsque vous recherchez votre nom sur Google ? HorsIndex analyse votre situation et vous accompagne dans votre demande de déréférencement.",
      },
      "/mentions-legales": {
        title: "Mentions légales | HorsIndex",
        description:
          "Mentions légales du site HorsIndex, service dédié à la réduction de l'exposition numérique professionnelle et patrimoniale.",
        robots: "noindex, follow",
      },
      "/conditions-generales": {
        title: "Conditions générales | HorsIndex",
        description:
          "Conditions générales des prestations HorsIndex : devis préalable, prix hors taxes, délais indicatifs et modalités d'exécution dans le cadre du CAPE avec Optéos.",
        robots: "noindex, follow",
      },
      "/politique-confidentialite": {
        title: "Politique de confidentialité | HorsIndex",
        description:
          "Politique de confidentialité du site HorsIndex relative au traitement des données transmises via les formulaires et échanges de contact.",
      },
      "/comprendre": {
        title: "Comprendre l'exposition numérique | HorsIndex",
        description:
          "Donnée publique et exposition publique : rediffusion, indexation nominative, agrégation de données, documents téléchargeables et cartographies.",
      },
      "/methode": {
        title: "Méthode HorsIndex — Cartographier, qualifier, agir",
        description:
          "Cartographier, qualifier, agir, documenter — avec une grille d'analyse des facteurs d'exposition, du résultat indexé à la base interne.",
      },
      "/cadre-juridique": {
        title: "Cadre juridique — RGPD, désindexation | HorsIndex",
        description:
          "RGPD, vie privée, CNIL, désindexation : pourquoi la publicité de la source ne justifie pas toutes les formes de rediffusion des données personnelles.",
      },
      "/services": {
        title: "Services HorsIndex — Réduire l'exposition publique",
        description:
          "Cartographie de l'exposition publique, retrait et masquage, désindexation, documents téléchargeables, cartographies : une démarche graduée et documentée.",
      },
      "/outil-interne": {
        title: "Outil interne HorsIndex — Cartographie et suivi",
        description:
          "L'outil interne HorsIndex cartographie les sources d'exposition, suit les démarches engagées et maintient une vision d'ensemble dans la durée.",
        robots: "noindex, nofollow",
      },
    },
  },
};
